<script>
  import { heroThemeStore } from "$lib/stores";

  // @ts-check
  import {
    ActionBar,
    DynamicHeading,
    Grid,
    GridContainer,
    Link,
    ImageContent,
    utilities
  } from "@ObamaFoundation/of-design-system";
  import { afterUpdate } from "svelte";

  /**
   * Primarily used for testing
   * @type {string} */
  export let id = undefined;

  let className = "";
  export { className as class };

  /**
   * Call to action for the eyebrow text
   * @type {import('@ObamaFoundation/of-design-system/dist/types/shared.js').CTA}
   */
  export let eyebrowCta = null;

  /**
   * The second part of the title that will be the same for all heroes
   * @type {string} */
  export let title;

  /**
   * The theme of the hero section to be used on small and medium breakpoints
   * @type {import('@ObamaFoundation/of-design-system/dist/utilities/themes.js').ThemeName}
   */
  export let theme = "white";

  /**
   * Optional action bar to display below the title
   * @type {import("@ObamaFoundation/of-design-system/dist/molecules/ActionBar/ActionBar.svelte").ActionBar}
   */
  export let actionBar = null;

  /**
   * The featured image in the hero section
   * @type {import('@ObamaFoundation/of-design-system/dist/types/shared.js').Image}
   */
  export let featuredImage = undefined;

  afterUpdate(() => {
    // Used to update the the Global Navigation background color based on current Home Hero background color
    heroThemeStore.set(theme);
  });

  $: currentTheme = utilities.getTheme(theme);
</script>

<div class="-mt-[var(--nav-height)] relative {className}">
  <GridContainer
    {id}
    containerElement="section"
    containerClass="{currentTheme.backgroundColor} pt-15 md:pt-20 xl:pt-25 pb-grid-margin"
    gridInnerClasses="flex flex-col xl:gap-15 lg:gap-10 gap-7.5 pt-[var(--nav-height)]"
  >
    <Grid>
      <div class="col-span-full flex flex-col gap-1 lg:col-span-9 lg:gap-3 xl:gap-4">
        {#if eyebrowCta}
          <Link
            class="label"
            href={eyebrowCta.url}
            isExternal={eyebrowCta.isExternal}
            label={eyebrowCta.text}
            variant="small"
            {theme}
            id={eyebrowCta.id}
            hideInternalLinkArrow={true}
          />
        {/if}
        <DynamicHeading class="{currentTheme.textColor} heading-md whitespace-pre-line">
          {title}
        </DynamicHeading>
      </div>
    </Grid>
    {#if actionBar}
      <ActionBar {theme} {...actionBar} />
    {/if}
    {#if featuredImage}
      <ImageContent image={featuredImage} containerClasses="w-full max-lg:mt-2.5" />
    {/if}
  </GridContainer>
</div>
